import { IconButton, Tooltip } from '@mui/material';
import type { ReactNode } from 'react';

interface InlineMenuButtonProps {
  children: ReactNode;
  label: string;
  onClick: () => void;
  separatedStart?: boolean;
  separatedEnd?: boolean;
}

export function InlineMenuButton({
  children,
  label,
  onClick,
  separatedStart = false,
  separatedEnd = false,
}: InlineMenuButtonProps) {
  return (
    <Tooltip title={label}>
      <IconButton
        aria-label={label}
        onClick={onClick}
        size="small"
        sx={{
          borderLeft: separatedStart ? '2px solid #f3f5f8' : undefined,
          borderRight: separatedEnd ? '2px solid #f3f5f8' : undefined,
          borderRadius: 0,
          color: '#111',
          height: 36,
          px: 0.75,
          width: 42,
          '&:hover': { backgroundColor: '#d8f7ff' },
        }}
      >
        {children}
      </IconButton>
    </Tooltip>
  );
}
